import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "flex-wrap-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", strokeLinecap: "round" },
        React.createElement("path", { stroke: "currentColor", d: "M9 4.5h2.75a2.75 2.75 0 0 1 2.75 2.75v.25a3 3 0 0 1-3 3h-8 0" }),
        React.createElement("path", { fill: "currentColor", stroke: "color(display-p3 0.000 0.000 0.000)", strokeLinejoin: "round", d: "m4.5 12.25-2-1.75 2-1.75z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
